/**
 * OneSignal Configuration
 * Environment-specific OneSignal App ID and settings
 */

//Testing
const ONESIGNAL_APP_ID = "d68a0a0e-c34c-4bae-9646-86cc8951b038";
//UAT
//const ONESIGNAL_APP_ID = "3cdf8e04-1807-4bef-88a6-d66ba108d0aa"; 

// OneSignal configuration
export const oneSignalConfig = {
  // OneSignal App ID - get from OneSignal dashboard
  appId: ONESIGNAL_APP_ID,

  // Allowed hosts for push notifications
  allowedHosts: [
    "localhost:3000",
    "localhost:4040",
    "localhost:5171",
    "absolute-uat-backend.binarywavesolutions.com",
    "absolute-backend.binarywavesolutions.com",
  ],

  // Allow localhost in development
  allowLocalhostAsSecureOrigin: process.env.NODE_ENV === "development",

  // Service worker paths
  serviceWorkerPath: "/OneSignalSDKWorker.js",
  serviceWorkerUpdatePath: "/OneSignalSDKUpdaterWorker.js",

  // Notification settings
  notificationClickHandlerMatch: "origin",
  autoResubscribe: true,

  // Feature flags
  enableNotificationPermissionPrompt: false, // We handle this manually
  enableWelcomeNotification: false,
  enablePushNotifications: true,

  // Debug mode for development
  debug: process.env.NODE_ENV === "development",
};

/**
 * Validate OneSignal configuration
 * @returns {boolean} - True if valid, false otherwise
 */
export const isOneSignalConfigValid = () => {
  if (!ONESIGNAL_APP_ID || ONESIGNAL_APP_ID === "YOUR_ONESIGNAL_APP_ID") {
    console.error(
      "[OneSignal Config] App ID not set. Please set REACT_APP_ONESIGNAL_APP_ID environment variable."
    );
    return false;
  }
  return true;
};

/**
 * Get environment name
 * @returns {string} - 'development', 'staging', or 'production'
 */
export const getEnvironmentName = () => {
  if (window.location.hostname.includes("localhost")) {
    return "development";
  } else if (window.location.hostname.includes("uat")) {
    return "staging";
  } else {
    return "production";
  }
};

/**
 * Is production environment
 * @returns {boolean}
 */
export const isProduction = () => {
  return getEnvironmentName() === "production";
};

export default oneSignalConfig;
